import { Button, Grid, InputLabel, Typography, TextField, InputAdornment } from '@mui/material'
import React, { ReactElement } from 'react'

import { theme } from '@react/components/theme'

import { useOtDispatch, useOtSelector } from '@react/redux/store'
import { PoolDynamicOverviewCTO } from '@shared/PoolDynamicCTO'
import { EthAddr } from '@shared/SchemaTypes'
import { dynamicSetIndicativeInterestRateTx } from '@react/signedTxs/dynamicSetIndicativeInterestRate'

export default function DynamicSetIndicativeInterestAndCollateralRateForm(props: { poolAddr: EthAddr }): ReactElement {
  const { poolAddr } = props
  const poolCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr] as PoolDynamicOverviewCTO)

  const dispatch = useOtDispatch()

  console.log('poolCTO', poolCTO)

  const [indicativeInterestRate, setIndicativeInterestRate] = React.useState<string>(
    (Number(poolCTO.indicativeInterestRate) / 100).toString()
  )
  const [collateralRate, setCollateralRate] = React.useState<string>((Number(poolCTO.collateralRate) / 100).toString())

  const [errorAmount, _setErrorAmount] = React.useState<string | undefined>(undefined)
  const [isSubmitted, setIsSubmitted] = React.useState(false)

  const sx = {
    backgroundColor: theme.palette.fg.main,
    color: '#FFFFFF',
    padding: '11px 16px 11px 16px',
    marginLeft: '8px',
    borderRadius: '6px',
    marginTop: 2,
  }
  const setRatesAction = (): void => {
    setIsSubmitted(true)
    dispatch(
      dynamicSetIndicativeInterestRateTx({
        poolAddr,
        indicativeInterestRate: Math.floor(Number(indicativeInterestRate) * 100).toString(),
        collateralRate: Math.floor(Number(collateralRate) * 100).toString(),
      })
    )
    const event = new Event('modalClose')
    window.dispatchEvent(event)
  }

  // TODO: Write tests

  return (
    <div data-testid="SET_INDICATIVE_INTEREST_AND_COLLATERAL_RATES_FORM">
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Typography variant="body" align="left" sx={{ marginBottom: 2 }}>
            Dynamic Exchange rate form
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ marginTop: 2 }}>
        <Grid item xs={12}>
          <Typography variant="bodyBold">Current Indicative Interest Rate: {poolCTO.indicativeInterestRate}</Typography>
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor="indicativeInterestRate">Indicative Interest Rate</InputLabel>
          <TextField
            id="indicativeInterestRate"
            inputProps={{
              'data-testid': 'indicativeInterestRate',
            }}
            sx={{ width: '300px' }}
            variant="outlined"
            placeholder="Enter Indicative Interest Rate"
            value={indicativeInterestRate}
            type={'tel'} //???
            onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
              setIndicativeInterestRate(event.target.value)
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            error={!!errorAmount}
            helperText={errorAmount}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="bodyBold">Current Collateral Rate: {poolCTO.collateralRate}</Typography>
        </Grid>
        <Grid item xs={12}>
          <InputLabel htmlFor="collateralRate">Collateral Rate</InputLabel>
          <TextField
            id="collateralRate"
            inputProps={{
              'data-testid': 'collateralRate',
            }}
            sx={{ width: '300px' }}
            variant="outlined"
            placeholder="Enter Collateral Rate"
            value={collateralRate}
            type={'tel'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>): void => {
              setCollateralRate(event.target.value)
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            error={!!errorAmount}
            helperText={errorAmount}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          disabled={isSubmitted}
          sx={sx}
          onClick={() => {
            setRatesAction()
          }}
          variant={'contained'}
        >
          <Typography variant={'buttonBold'}>Set Rates</Typography>
        </Button>
      </Grid>
    </div>
  )
}
